// app/ningenie/lib/service-worker.ts
// baby: Service worker registration for PWA functionality

export const registerServiceWorker = async (): Promise<void> => {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) {
    console.log('Service Worker not supported')
    return
  }

  try {
    const registration = await navigator.serviceWorker.register('/ningenie-sw.js', {
      scope: '/ningenie/'
    })
    
    console.log('Service Worker registered:', registration.scope)

    // baby: check for updates
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // baby: new service worker available
            console.log('New service worker available')
          }
        })
      }
    })
  } catch (error) {
    console.error('Service Worker registration failed:', error)
  }
}

export const unregisterServiceWorker = async (): Promise<void> => {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  try {
    const registration = await navigator.serviceWorker.getRegistration('/ningenie/')
    if (registration) {
      await registration.unregister()
      console.log('Service Worker unregistered')
    }
  } catch (error) {
    console.error('Service Worker unregistration failed:', error)
  }
}

